import React from 'react';
import {XCircleIcon} from "@heroicons/react/24/outline";
export default function SelectedSitesList({filteredSites, toggleSite, clearSites}) {
  return (
    <div className="flex flex-wrap gap-1">
      {filteredSites.length > 0 && <span className="leading-5 py-1">You have selected:</span>}
      {filteredSites.map(site => (
        <div key={site.id}
             className="flex h-7 min-w-9 p-2 justify-center items-center gap-1 rounded-lg bg-cs-orange-500/10 text-xs leading-4">{site.name}
          <button className="rounded-full text-black" onClick={() => toggleSite(site.id)}>
            <XCircleIcon className=" h-4 w-4"/>
          </button>
        </div>
      ))}
      <button className="btn btn-ghost !active:border-0 underline !py-1" disabled={filteredSites.length === 0}
              onClick={() => clearSites()} data-cy="clear-site-filters-btn">Reset filters
      </button>
    </div>
  );
}
